webpackJsonp([245665268606781],{

/***/ 1598:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"UpsertProductConfigInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"defaultNotes","type":{"kind":"SCALAR","name":"String","ofType":null}},{"defaultValue":null,"description":null,"name":"dosageConfig","type":{"kind":"INPUT_OBJECT","name":"DosageConfigInput","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-upsert-product-config-input-23bfe341cece068722b4.js